module.exports = __webpack_public_path__ + "static/media/MaskGroup 2.f112c368.png";